
export const dashboardEndpoints = {
    getAnalyticalDashboardHeadCount: '/api/Dashboard/GetAnalyticalDashboardHeadCount',
    getProjectDashboardHeadCount: '/api/Dashboard/GetProjectDashboardHeadCount',
    getProjectDashboard: '/api/Dashboard/GetProjectDashboard',
    getCompanyDashboard: '/api/Dashboard/GetCompanyDashboard',
    getProjectAllDashboard: '/api/Dashboard/GetProjectAllDashboard',
    getProjectMonthlyTaskCount: '/api/Dashboard/GetProjectMonthlyTaskCount',
    getClientMonthlySaleCount: '/api/Dashboard/GetClientMonthlySaleCount',
    getDataCount: '/api/Dashboard/GetDataCount',
    getTenantSize: '/api/Dashboard/GetTenantSize',
    getTaskData: '/api/Dashboard/GetTaskData',
    getDashboardDataMobile: '/api/Dashboard/GetDashboardDataMobile',
    getDashboardCountDataMobile: '/api/Dashboard/GetDashboardCountDataMobile',
    dashboardChartCountMobile: '/api/Dashboard/DashboardChartCountMobile',
    addTeamNotice: '/api/Dashboard/AddTeamNotice',
    getProjectTaskData: '/api/Dashboard/GetProjectTaskData',
    getProjectData: '/api/Dashboard/GetProjectData',
    getMemberWiseTasks: '/api/Dashboard/GetMemberWiseTasks',
    getTodayActivity: '/api/Dashboard/GetTodayActivity',
    getAnalyticalDashboardCount: '/api/Dashboard/GetAnalyticalDashboardCount',
    getProjectDashboardCount: '/api/Dashboard/GetProjectDashboardCount',
    getCurrentDateActivities: '/api/Dashboard/GetCurrentDateActivities',
    getClientDashboard: '/api/Client/GetAllClientDashboard',
    insertEmployeeStatus: 'api/EmployeeStatus/Insert',
    updateProfile: 'api/Employee/MobileUpdate',
    changeProfile: 'api/LoginAuth/ChangePassword'

  };
  